import { CommandService } from "Service/CommandService";
import { BaseService } from "Service/BaseService";
import { IExportContextParameter, IExportColumn } from "Entities";
import { Configuration } from "Configuration";

import { saveAs } from "file-saver";
import { CoreContext } from "Core";

/**
 * Service for exporting grid data.
 * @hidden
 */
export class ExportService extends BaseService {
    /**
     * Export a grid to excel.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public export(
        gridId: number,
        filterId: number,
        textBlockCategory: string,
        commandOption: any,
        columns: IExportColumn[]
    ): Promise<void> {
        let exportParam: IExportContextParameter = {
            GridID: gridId,
            TextBlockCategory: textBlockCategory,
            Columns: columns
        };
        if (filterId != null) {
            exportParam.FilterID = filterId;
        }
        let parameters = $.extend(exportParam, CommandService.getRequestParameters());
        parameters.Options = commandOption;
        parameters.TimezoneIANA = CoreContext.Environment.ClientTimeZone;
        exportParam.ApplicationParameters["IsExcelExport"] = "1";
        return this.post(Configuration.baseUrl + "export", parameters, "binary").then((data: BlobPart) => {
            let blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
            saveAs(blob, CoreContext.Instance.mappingName + ".xlsx");
        });
    }
}
